module.exports = __webpack_public_path__ + "img/Security.46d00918.jpg";